import { Injectable, computed, signal } from '@angular/core';

/**
 * Tracks whether a page currently renders its own {@link VexSecondaryToolbarComponent}.
 *
 * The secondary toolbar hosts the page title, actions and the route-driven
 * breadcrumb trail. Pages that do NOT render one (e.g. the interventions hub or
 * the financial dashboard) would otherwise leave the reserved header strip blank
 * and lose their breadcrumbs. The layout watches {@link present} and renders a
 * breadcrumbs-only fallback bar in that same strip whenever no page toolbar is
 * mounted, so the header is consistent across every screen.
 *
 * A counter (not a boolean) is used so overlapping mount/unmount during a route
 * transition never flips the flag off while a toolbar is still on screen.
 */
@Injectable({ providedIn: 'root' })
export class SecondaryToolbarPresenceService {
  private readonly count = signal(0);

  /** True while at least one page-level secondary toolbar is mounted. */
  readonly present = computed(() => this.count() > 0);

  register(): void {
    this.count.update((n) => n + 1);
  }

  unregister(): void {
    this.count.update((n) => Math.max(0, n - 1));
  }
}
